// App.js
import { React, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Home from "./components/Home";
import WaterQualityAnalysis from "./components/WaterQualityAnalysis";
import Login from "./components/Login";
import EcoWaterReport from "./components/EcoWaterReport";
import ModifyWaterReport from "./components/ModifyWaterReport";
import UpdateConcentration from "./components/UpdateConcentration";
import UpdateControlParameters from "./components/UpdateControlParameters";
import NavBar from "./components/NavBar";
import { AuthProvider, useAuth } from "./context/AuthContext"; // Correct import

function App() {
  return (
    <AuthProvider>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route
            path="/water-quality"
            element={
              <ProtectedRoute>
                <WaterQualityAnalysis />
              </ProtectedRoute>
            }
          />
          <Route
            path="/eco-water-report"
            element={
              <ProtectedRoute>
                <EcoWaterReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/modify-water-report"
            element={
              <ProtectedRoute>
                <ModifyWaterReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-concentration"
            element={
              <ProtectedRoute>
                <UpdateConcentration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-water-control"
            element={
              <ProtectedRoute>
                <UpdateControlParameters />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay to wait for the authentication check
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100); // Adjust the delay as needed
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <div>Loading...</div>; // Show a loading spinner or message
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

export default App;
